import url from './url';

async function getAluno(token) {

    let data = await fetch(`${url}/aluno/show`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

async function updateAluno(token, payload) {

    return await fetch(`${url}/aluno/update`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'put',
        body: JSON.stringify(payload)
    }).then(res => res.json());
    
}

async function createAlunoAula(token, payload) {

    return await fetch(`${url}/aluno/aula`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'post',
        body: JSON.stringify(payload)
    }).then(res => res.json());

}

async function createAlunoAulaLike(token, payload) {

    return await fetch(`${url}/aluno/aula/like`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'post',
        body: JSON.stringify(payload)
    }).then(res => res.json());

}

async function createAlunoAulaArquivo(token, payload) {

    return await fetch(`${url}/aluno/aula/arquivo`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'post',
        body: JSON.stringify(payload)
    }).then(res => res.json());

}

async function checkAula(token, payload) {

    return await fetch(`${url}/aluno/aula/check`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'post',
        body: JSON.stringify(payload)
    }).then(res => res.json());

}

async function aulasAssistidas(token, cdCurso, cdSubtema) {

    return await fetch(`${url}/aluno/minhas-aulas-assistidas?cd_curso=${cdCurso}&cd_subtema=${cdSubtema}`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'get'
    }).then(res => res.json());

}

async function listaArquivosAula(token) {

    return await fetch(`${url}/aluno/assistir-mais-tarde`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'get'
    }).then(res => res.json());

}

export { getAluno, updateAluno, createAlunoAula, createAlunoAulaLike, createAlunoAulaArquivo, checkAula, aulasAssistidas, listaArquivosAula }